import {Record} from 'immutable';

const Typeface = Record({
  id: null,
  link: null,
  name: '',
  family: '',
  weight: '',
  style: '',
  creatorName: '',
  system: false,
  fileSize: 0,
});

export default Typeface;



// WEBPACK FOOTER //
// ./app/javascript/records/Typeface.js